<template>
<div class="zzd">
  <div class="IDdy">
    <ul class="xx">
      <li>患者姓名：{{csgk.CustomerName}}</li>
      <li>性别：{{csgk.CustomerGender == 1 ? '男' : '女'}}</li>
      <li>年龄：{{csgk.CustomerAge}}</li>
      <li>联系电话：{{csgk.CustomerTel}}</li>
    </ul>

    <h3>转出资料</h3>
    <div class="boxp">
      <p class="pd-r15">转出单位：{{bddw.ShopName}}</p>
      <p class="pd-r15">地址：{{bddw.ShopAddress}}</p>
      <p>电话：{{bddw.ShopTel}}</p>
    </div>
    <div class="boxp">
      <p>就诊时间：</p>
      <el-date-picker
          format="yyyy/MM/dd"
          value-format="yyyy/MM/dd"
          style="width: 250px;margin-right: 30px;"
          v-model="zzData.jzsj"
          type="date"
          size="small">
      </el-date-picker>
      <p>转出时间：</p>
      <el-date-picker
          format="yyyy/MM/dd"
          value-format="yyyy/MM/dd"
          style="width: 250px;"
          v-model="zzData.zcsj"
          type="date"
          size="small">
      </el-date-picker>
    </div>
    <div class="boxp">
      <p>诊断结论：</p>
      <div style="text-align: left;">
        <p>右眼：{{zdod}}</p>
        <p>左眼：{{zdos}}</p>
      </div>
    </div>
    <div class="boxp">
      <p>备注：</p>
      <el-input style="width: 630px;" v-model="zzData.bz" placeholder="请输入内容"></el-input>
    </div>
<!--    <div class="boxp">-->
<!--      <p>医生签字：</p>-->
<!--      <el-button size="mini" type="primary">签名</el-button>-->
<!--      <p style="padding-left: 20px;">时间：1822/4/22</p>-->
<!--    </div>-->


    <h3>转入资料</h3>
    <div class="boxp">
      <p>转入单位：</p>
      <el-select style="margin-right: 20px;" v-model="zrdwIdx" @change="zrdwbh" filterable class="xza"  size="small" placeholder="请选择">
        <el-option
            v-for="item in zrdwArr"
            :key="item.value"
            :label="item.label"
            :value="item.value">
        </el-option>
      </el-select>
<!--      <p class="pd-r15">科室：时间啊看啥客家话</p>-->
      <p>地址信息：{{dqZrdw.CC_Address}}</p>
    </div>
    <div class="boxp">
      <p>联系人：{{dqZrdw.CC_Person}}</p>
      <p style="padding-left: 20px;">联系电话：{{dqZrdw.CC_Tel}}</p>
    </div>
    <div class="boxp">
      <p>预约时间：</p>
      <el-date-picker
          format="yyyy/MM/dd"
          value-format="yyyy/MM/dd"
          style="width: 250px;margin-right: 63px;"
          v-model="zzData.yysj"
          type="date"
          size="small">
      </el-date-picker>
      <p>转入科室：</p>
      <el-select  v-model="zzData.ks" filterable class="xza"  size="small" placeholder="请选择">
        <el-option
            v-for="item in ksarr"
            :key="item.value"
            :label="item.label"
            :value="item.value">
        </el-option>
      </el-select>
    </div>

    <div class="boxp">
      <p>转入单位接诊注意事项：</p>
      <el-input style="width: 515px;" v-model="zzData.zysx" placeholder="请输入内容"></el-input>
    </div>
  </div>
  <div style="padding-top: 20px;">
    <el-button type="primary" @click="save">提交</el-button>
    <el-button type="info" @click="dy">打印</el-button>
  </div>
</div>
</template>

<script>
import {getHzdw, addhzZz} from "./api";
import { VuePrintNext } from 'vue-print-next';
export default {
  name: "zzd",
  data() {
    return {
      zzData: {
        bz: '',
        zrid: '',
        jzsj: '',
        zcsj: '',
        zysx: '',
        ks: '',
        yysj: ''
      },

      zrdwArr: [],
      zrdwAllArr: [],
      zrdwIdx: '',
      dqZrdw: {},
      ksarr: [],
      csgk: {},
      bddw: {},
      zdod: '',
      zdos: ''
    }
  },
  created() {
    // console.log(this.$store.state.users.user)
    getHzdw()
        .then(res => {
          let arr = []
          if (res.Result && res.Result.length) {
            this.zrdwAllArr = [...res.Result]
            for (let i = 0; i < res.Result.length; i++) {
              arr.push({
                value: i,
                label: res.Result[i].CC_Name
              })
              this.zrdwArr = [...arr]
            }
          }
        })


    let log = this.$loading({
      text: '加载中...'
    })

    this._api.expertClinic.getExpertClinic()
        .then(res => {
          log.close()
          if (res.GetResult) {
            res.GetResult.S_OP_Json = this._clJson(res.GetResult.S_OP_Json)
            let jlzdp = res.GetResult.S_OP_Json.CheckResult_20250918_Diagnosis_OD
            if (jlzdp) {
              this.zdod = jlzdp.replace(/-/g, ",")
            }

            let jlzdpos = res.GetResult.S_OP_Json.CheckResult_20250918_Diagnosis_OS
            if (jlzdpos) {
              this.zdos = jlzdpos.replace(/-/g, ",")
            }
          }
        })

    if (this.$store.state.users.CsUser) {
      this.csgk = JSON.parse(JSON.stringify(this.$store.state.users.CsUser))
    }


    this.bddw = JSON.parse(JSON.stringify(this.$store.state.bases.shop))
  },
  methods: {
    zrdwbh(e) {
      this.dqZrdw = this.zrdwAllArr[e]
      this.zzData.zrid = this.zrdwAllArr[e].CC_Id
      if (this.dqZrdw.CC_DeptName) {
        let arr = this.dqZrdw.CC_DeptName.split(','),
            oparr = []
        for (let i = 0; i < arr.length; i++) {
          oparr.push({
            value:arr[i],
            label: arr[i]
          })
          this.ksarr = [...oparr]
        }
      }
    },
    dy() {
      new VuePrintNext({el: '.IDdy'})
    },
    save() {
      if (!this.$store.state.expertClinic.qmUrl) return this.$alert('请医生先在小程序上设置签名！', '提示')
      if (!this.zzData.zrid) return this.$alert('请选择入诊单位', '提示')
      if (!this.zzData.jzsj) return this.$alert('请选择就诊时间', '提示')
      if (!this.zzData.zcsj) return this.$alert('请选择转出时间', '提示')
      if (!this.zzData.ks) return this.$alert('请选择科室', '提示')
      if (!this.zzData.yysj) return this.$alert('请选择预约时间', '提示')
      let log = this.$loading({
        text: '添加中...'
      })
      addhzZz(this.zzData)
      .then(res => {
        log.close()
        if (res.ReturnCode == 5000) {
          this.$alert('添加成功！', '提示')
          .then(r => {
            this.$emit('sxgb', false)
          })
        }
        console.log(res)
      })
    }
  }
}
</script>

<style scoped lang="scss">
.zzd {color: #0a0a0a;font-size: 14px;}
.IDdy {font-size: 14px;}
.xx {
  display: flex;
  justify-content: center;
  li {padding: 0 15px;}
}
h3 {
  font-size: 15px;
  text-align: left;
  padding-top: 10px;
  padding-bottom: 5px;
}
.boxp {
  display: flex;
  align-items: center;
  padding-bottom: 10px;
}
.pd-r15 {padding-right: 20px;}
</style>
